import styled from 'styled-components'

import { StyledButton } from '../../Button/style'

export const DragQuestionResetStyledButton = styled(StyledButton)`
  margin-right: 10px;
  max-height: 2.25rem;
`

export const StoryContainer = styled.div`
  height: 100%;
  width: 100%;
  background-color: gray;
`
